import { render, staticRenderFns } from "./ModalPaymentMethods.vue?vue&type=template&id=16efb2e6&scoped=true&"
import script from "./ModalPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentMethods.vue?vue&type=script&lang=js&"
import style0 from "./ModalPaymentMethods.vue?vue&type=style&index=0&id=16efb2e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16efb2e6",
  null
  
)

export default component.exports